// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';

import { loadAppointments, deleteAppointment } from 'actions/appointments';
import type { AppointmentType } from 'actions/appointments';

import Appointment from 'components/Appointment';

import NewAppointment from './NewAppointment';

type Props = {
  // redux
  appointments: Array<AppointmentType>,
  onLoadAppointments: typeof loadAppointments,
  onDeleteAppointment: typeof deleteAppointment,
};

class Appointments extends React.Component<Props> {
  componentDidMount() {
    this.props.onLoadAppointments();
  }

  render() {
    const {
      appointments,
      onDeleteAppointment,
      onLoadAppointments,
    } = this.props;

    return (
      <div className="animated fadeIn">
        <Container fluid>
          <Row>
            <Col>
              {appointments.map(a => (
                <Appointment
                  key={a.appointmentId}
                  appointmentId={a.appointmentId}
                  title={a.title}
                  description={a.description}
                  image={a.image}
                  dates={a.dates}
                  createdAt={a.createdAt}
                  onDeleteAppointment={async () => {
                    await onDeleteAppointment(a.appointmentId);
                    onLoadAppointments();
                  }}
                />
              ))}
            </Col>
            <Col xs="12" sm="12" md="12" lg="5" xl="5">
              <NewAppointment />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ appointments: { all: appointments } }) => ({
  appointments,
});
const mapDispatchToProps = dispatch => ({
  onLoadAppointments: (...args) => dispatch(loadAppointments(...args)),
  onDeleteAppointment: (...args) => dispatch(deleteAppointment(...args)),
});

const AppointmentsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Appointments);

export default AppointmentsContainer;



// WEBPACK FOOTER //
// ./src/views/Appointments/Appointments.js